import { TeamYear } from "./types";

export const team2023_24: TeamYear = {
  year: "2023-24",
  facultyAdvisors: [{
      id: "fac-1",
      name: "Dr. K.S.Tiwari",
      role: "Faculty Coordinator",
      image: "/team/common/tiwari-mam.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://linkedin.com/in/dr-kanchan-s-tiwari-01705171"},
    },
    {
      id: "fac-2",
      name: "Prof. Yogita Ajgar",
      role: "Faculty Coordinator",
      image: "/team/common/yogita-mam.jpg",
      deptOrBranch: "E&TC Department",
      social: { linkedin: "https://linkedin.com/in/yogita-ajgar-847b1071" },
    },],
  founder: [{
      id: "founder-1",
      name: "Arnav Botre",
      role: "Founder",
      image: "/team/common/arnav.jpg",
      deptOrBranch: "Alumni - E&TC",
      social: { linkedin: "https://www.linkedin.com/in/arnav-botre-b2a7591b2/", instagram:"https://www.instagram.com/arnav_botre14/", email: "botrearnav@gmail.com" },
    },],
  coreCommittee: [
    {
      id: "core-1",
      name: "Prasad Nikam",
      role: "President",
      image: "/team/2023-24/prasad.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/prasad-nikam-6176a1231", instagram: "https://www.instagram.com/_prasad_nikam/", email:"prasadnikam2003@gmail.com"},
    },
    {
      id: "core-2",
      name: "Nirbhay Khande",
      role: "Vice President",
      image: "/team/2023-24/nirbhay.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/nirbhay-khande-91984a231", instagram: "https://www.instagram.com/_me_nirbhay_/", email: "nckhande7551@gmail.com" },
    },
   {
      id: "core-3",
      name: "Kedarnath Tawde",
      role: "Treasurer",
      image: "/team/2023-24/kedarnath.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/kedar-tawde-527839231",instagram :"https://www.instagram.com/kedar._tawde/",  email:"tawdekedar@gmail.com"},
    },
    {
      id: "core-4",
      name: "Vighnesh Khichade",
      role: "Documentation Head",
      image: "/team/2023-24/vighnesh.webp",
      deptOrBranch: "",
      social: { linkedin: "https://linkedin.com/in/vighnesh-a-p-khichade-03346a267", instagram: "https://www.instagram.com/vighnesh_apk?igsh=aWEyMmNiOHRrOXVk", email:"vighneshapkedu@gmail.com" },
    },
    {
      id: "core-5",
      name: "Prathamesh Bargaje",
      role: "Publicity & Marketing Head",
      image: "/team/2023-24/prathamesh.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/prathamesh-bargaje-503001232", instagram:"https://www.instagram.com/prathamesh_bargaje/", email: "bargajeprathamesh@gmail.com" },
    },
    {
      id: "core-6",
      name: "Sakshi Deokar",
      role: "Publicity & Marketing Head",
      image: "/team/2023-24/sakshi.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/sakshi-deokar-987b30231", instagram: "https://www.instagram.com/sakshideokar19/", email:"sakshideokar19012003@gmail.com" },
    },
    {
      id: "core-7",
      name: "Samruddhi Kale",
      role: "Event Head",
      image: "/team/2023-24/samruddhi.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/samruddhi-kale-759a08231", instagram: "https://www.instagram.com/samruddhi.654/", email: "kalesamruddhi6@gmail.com" },
    },
    {
      id: "core-8",
      name: "Kartik Hole",
      role: "Event Head",
      image: "/team/2023-24/kartik.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/kartik-hole-4420a7287/", instagram: "https://www.instagram.com/_alterego14_/", email:"kartikhole2@gmail.com" },
    },
    {
      id: "core-9",
      name: "Vishnu Popalghat",
      role: "Web Developer",
      image: "/team/2023-24/vishnu.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/vishnupopalghat", instagram: "https://www.instagram.com/vishnu_6409/", email: "vishnupopalghat062003@gmail.com" },
    },
    {
      id: "core-10",
      name: "Akshada Phadatare",
      role: "Social Media Head",
      image: "/team/2023-24/akshada.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/akshada-phadatare-422630231",instagram: "https://www.instagram.com/1608_akshada_phadatare/", email: "akshadaphadatare49@gmail.com" },
    },
    {
      id: "core-11",
      name: "Saniya Gharge",
      role: "Social Media Head",
      image: "/team/2023-24/saniya.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/saniya-gharge-2aa317287",instagram: "https://www.instagram.com/saaniiiyaaaaaaa/", email: "saniyagharge1407@gmail.com" },
    },
    {
      id: "core-12",
      name: "Shraddha Mirkhalkar",
      role: "Student Co-ordinator (ENTC & AR)",
      image: "/team/2023-24/shraddha.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/shraddha-mirkhalkar-018182285?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", instagram: "https://www.instagram.com/shraddhaaa__22?igsh=aGl5OHlmZnl3bm9w", email: "mirkhalkarshraddha22@gmail.com" },
    },
    {
      id: "core-13",
      name: "Shreed Raskar",
      role: "Student Co-ordinator (Comp & AR)",
      image: "/team/2023-24/shreed.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/shreed-raskar-646b20254",instagram: "https://www.instagram.com/shreed_95/", email: "shreedraskar48@gmail.com" },
    },
    {
      id: "core-14",
      name: "Pavan Kodlinge",
      role: "Student Co-ordinator (AR & Mech)",
      image: "/team/2023-24/pavan.webp",
      deptOrBranch: "",
      social: { linkedin: "https://www.linkedin.com/in/pavan-kodlinge-759673313", email:"pavankodlinge2@gmail.com" },
    },
  ],
};

export {}; // ✅ This ensures it is treated as a module
